document.addEventListener( 'DOMContentLoaded', function () {
	const MOBILE_BREAKPOINT = 1024;
	const sections = document.querySelectorAll( '.audience-section' );

	sections.forEach( function ( section ) {
		const tabs = section.querySelectorAll( '.audience-section__tab' );
		const panels = section.querySelectorAll( '.audience-section__panel' );
		const panelsContainer = section.querySelector( '.audience-section__panels' );
		const dots = section.querySelectorAll( '.audience-section__dot' );

		/* ── Desktop: Tab clicks ── */
		tabs.forEach( function ( tab ) {
			tab.addEventListener( 'click', function () {
				const target = tab.getAttribute( 'data-tab' );

				tabs.forEach( function ( t ) {
					t.classList.remove( 'audience-section__tab--active' );
				} );
				tab.classList.add( 'audience-section__tab--active' );

				const currentPanel = section.querySelector( '.audience-section__panel--active' );
				const nextPanel = section.querySelector(
					`.audience-section__panel[data-panel="${ CSS.escape( target ) }"]`
				);

				if ( currentPanel && nextPanel && currentPanel !== nextPanel ) {
					// Pure CSS opacity cross-fade via grid stacking — no position switching needed
					currentPanel.classList.remove( 'audience-section__panel--active' );
					nextPanel.classList.add( 'audience-section__panel--active' );
				} else if ( nextPanel ) {
					panels.forEach( function ( p ) {
						p.classList.remove( 'audience-section__panel--active' );
					} );
					nextPanel.classList.add( 'audience-section__panel--active' );
				}
			} );
		} );

		/* ── Mobile: Swipe carousel + dots ── */
		function isMobile() {
			return window.innerWidth < MOBILE_BREAKPOINT;
		}

		function updateDots( activeIndex ) {
			dots.forEach( function ( dot, i ) {
				dot.classList.toggle( 'audience-section__dot--active', i === activeIndex );
			} );
		}

		// Dot click → scroll to panel
		dots.forEach( function ( dot ) {
			dot.addEventListener( 'click', function () {
				const target = parseInt( dot.getAttribute( 'data-dot' ), 10 );
				if ( panelsContainer && panels[ target ] ) {
					panelsContainer.scrollTo( {
						left: panels[ target ].offsetLeft - panelsContainer.offsetLeft,
						behavior: 'smooth',
					} );
				}
			} );
		} );

		// Scroll → update active dot
		if ( panelsContainer ) {
			let scrollTimeout;
			panelsContainer.addEventListener( 'scroll', function () {
				if ( ! isMobile() ) {
					return;
				}
				clearTimeout( scrollTimeout );
				scrollTimeout = setTimeout( function () {
					const scrollLeft = panelsContainer.scrollLeft;
					const containerWidth = panelsContainer.offsetWidth;
					const activeIndex = Math.round( scrollLeft / containerWidth );
					updateDots( activeIndex );
				}, 50 );
			} );
		}
	} );
} );
